import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../../../../constants/urls";
import { useCookies } from "react-cookie";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import CustomTable from "../../../CustomTable";
const LocationLogTable = (props) => {
    const [data, setDate] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();

    function getLogs(page) {
        const url = Constants.apiUrl + "/api/ag/locationLogs";
        axios
            .post(
                url,
                { page: page },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);
            })
            .catch((e) => {
                if (e.response.status == 403) {
                    window.location = "403";
                }
            });
    }

    const statusTitle = (step) => {
        let title = "0123456";
        if (step == 0) title = "حذف شده";

        if (step == 1) title = "مرحله اول   ";
        if (step == 2) title = "مرحله دوم   ";
        if (step == 3) title = "مرحله سوم   ";

        return step;
    };
    // useEffect(() => {
    //     getLogs(1);
    // }, []);
    return (
        <React.Fragment>
            <div className="container-fluid">
            <CustomTable
                apiUrl={"/api/ag/locationLogs"}
                columns={[
                    {
                        title:"لوکیشن",
                        name:"location"
                    },
                    {
                        title:"انبارگردانی",
                        name:"anbargardani"
                    },
                    {
                        title:"اپراتور",
                        name:"operator_name"
                    },
                    {
                        title:"وضعیت",
                        name:"step"
                    },
                ]}
                rows={[
                    "location",
                    "time",
                    "operator.name",
                    "step",
                ]}

                />

                <div className="mt-4">
                    <Link to={"/admin/anbargardani"}>
                        <button className="btn btn-block btn-danger">
                            خروج
                        </button>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
};
export default LocationLogTable;
